// @flow
import React from 'react';
import type { ComponentType } from 'react';

import type { LocalizedProps } from '@globalTypes';

type ContextValue<Data> = LocalizedProps<Data>;

const TranslationContext = React.createContext<Function>({
  localizedData: {},
  i18n: { language: 'en' }
});

export const TranslationContextProvider = TranslationContext.Provider;

function withTranslationContext<Data>(Component: ComponentType<Data>): Function {
  return (props: any) => (
    <TranslationContext.Consumer>
      {({ localizedData, i18n }: ContextValue<Data>) => (
        <Component {...props} localizedData={localizedData} i18n={i18n} />
      )}
    </TranslationContext.Consumer>
  );
}

export default withTranslationContext;
